var render = function render(){var _vm=this,_c=_vm._self._c;return _c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":"MailIcon","statistic":_vm.willsUnRead,"statisticTitle":_vm.subTitle,"color":_vm.colour,"to":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }